import {APIServiceResponse} from '@custom-types/APIServiceResponse';
import {ImageObj} from '@custom-types/ImageObj.types';
import {HttpRequest} from '@services/HttpClient';
import {APIInterface} from '@services/services.type';
import {trackErrorEvents} from '@utils/googleAnalytics/googleAnalyticsEvents';
import {getAPIUrl} from '@utils/service.utils';

export type requestLeadGenerationR = {
  success: boolean;
  errorMessage: string;
  message: {
    description: string;
    title: string;
    image?: ImageObj;
  };
};

type APIResponseData = {
  title: string;
  description: string;
  QRLink: ImageObj;
};

// this function is to request for lead generation
export function requestLeadGenerationAPI(
  payload: string | null | Record<string, any>
): APIInterface<undefined, requestLeadGenerationR> {
  const options = {
    method: 'POST' as const,
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(payload),
  };
  const route = `search/feature/lead`;
  const httpRequest = new HttpRequest(getAPIUrl('search', route), options);
  return {
    getResponse: async () => {
      try {
        const response =
          (await httpRequest.send()) as unknown as APIServiceResponse<APIResponseData>;
        return {
          success: true,
          errorMessage: '',
          message: parseSuccessResponse(response.data),
        };
      } catch (err: any) {
        trackErrorEvents({
          type: 'request_lead_generation_failed',
          errorStack: err,
        });
        throw err;
      }
    },
    abort: httpRequest.abort,
  };
}

function parseSuccessResponse(data: APIResponseData) {
  if (!data) {
    return {
      title: 'Thank You',
      description:
        'Thanks for getting in touch. A member of our team will get back to you as soon as possible.',
    };
  }
  return {
    title: data?.title || 'Thank You',
    description:
      data?.description ||
      ' Thanks for getting in touch. A member of our team will get back to you as soon as possible.',
    image: data?.QRLink,
  };
}
